module.exports = __webpack_public_path__ + "static/media/BannerD15.7b81d693.png";